import React, { Component } from 'react'
import './Stats.css';
import PropTypes from 'prop-types';
export default class Stats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myStats: [
        {
         
         languages:'TypeScript, JavaScript, SQL, C++, C#, Go, Rust, Python, Solidity',
         experience:4,
         projects:'Red Art Splash, BarberShop Template, Portfolio Project, The Merlin Group, PersonNFT, Go Blockchain, RustChain',
         sitesBuilt:'www.redartsplash.com https://themerlingroupworld.com/ https://samsalgado.github.io/SCP/, https://teaching-technology.netlify.app/',
         adjectives:'Manufacturing, Data Analytics, Wellness, Blockchain, Cybersecurity, Education',
         certifications:'JavaScript, React, Solidity, Python, Big Data, Hadoop'
        }
      ]
    };
  }
  componentDidMount() {
    const callback = () => {
      console.log("My Portfolio");
    }
    setTimeout(callback, 1000);
  }
  render() {
    return (
      <tr className="me-row">
        <td>{this.props.languages}</td>
        <td>{this.props.experience}</td>
        <td>{this.props.projects}</td>
        <td>{this.props.sitesBuilt}</td>
        <td>{this.props.adjectives}</td>
        <td>{this.props.certifications}</td>
      </tr>
    );
  }
}
Stats.propTypes = {
  languages: PropTypes.string,
  experience: PropTypes.number,
  college: PropTypes.string,
  sitesBuilt: PropTypes.string,
  adjectives: PropTypes.string,
  book: PropTypes.string
}